var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: { name: "billPaymentList" },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "custom-tab-label" }, [
                          _c(
                            "div",
                            { staticClass: "flat-tabs-container" },
                            [
                              !_vm.uiCustomEnable
                                ? [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "flat-tab-item",
                                          {
                                            active: _vm.applicationStatus === 0
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.switchTab(0)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_PaymentRequest"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm.uiCustomEnable
                                ? [
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbAll"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 5
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(5)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_AllPaymentRequests"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbWait"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 0
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(0)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("Payment.notSubmitted")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbApproval"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 1
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(1)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Payment.awaitBusinessApproval"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.billPaymentSetting.departmentApproval
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 6
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(6)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_PendingDepartmentApproval"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbFinanceVerify"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 2
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(2)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Payment.awaitFinancialApproval"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbSupervisorVerify"
                                    ]) &&
                                    _vm.billPaymentSetting.supervisorApproval
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 11
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(11)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_PendingSupervisorApproval"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbConfirm"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 3
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(3)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("Payment.approval")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "tab_ACPayAuth_fbUnverify"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 4
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(4)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("Payment.unpaid")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    !_vm.$checkPermission([
                                      "tab_ACPayAuth_fbAll"
                                    ]) &&
                                    !_vm.$checkPermission([
                                      "tab_ACPayAuth_fbWait"
                                    ]) &&
                                    !_vm.$checkPermission([
                                      "tab_ACPayAuth_fbApproval"
                                    ]) &&
                                    !_vm.billPaymentSetting
                                      .departmentApproval &&
                                    !_vm.$checkPermission([
                                      "tab_ACPayAuth_fbFinanceVerify"
                                    ]) &&
                                    (!_vm.$checkPermission([
                                      "tab_ACPayAuth_fbSupervisorVerify"
                                    ]) ||
                                      !_vm.billPaymentSetting
                                        .supervisorApproval) &&
                                    !_vm.$checkPermission([
                                      "tab_ACPayAuth_fbConfirm"
                                    ]) &&
                                    !_vm.$checkPermission([
                                      "tab_ACPayAuth_fbUnverify"
                                    ])
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "flat-tab-item",
                                              {
                                                active:
                                                  _vm.applicationStatus === 5
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.switchTab(0)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_PaymentRequest"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c("bill-payment-list", {
                  ref: "billPaymentList",
                  attrs: {
                    "is-append-query": true,
                    "show-wht": true,
                    "view-source": "basic",
                    "bill-payment-setting": _vm.billPaymentSetting,
                    "application-status": _vm.applicationStatus
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }